import React from 'react';
import { Hue, Saturation } from 'react-color/lib/components/common';
import cn from 'classnames';

import styles from './ColorPicker.module.scss';

const HuePointer = () => <div className={styles.huePointer} />;

const SaturationPointer = () => <div className={styles.saturationPointer} />;

const ColorPicker = ({
  className,
  hsl,
  hsv,
  onSaturationChange,
  onHueChange,
}: {
  className: any;
  hsl: any;
  hsv: any;
  onSaturationChange: any;
  onHueChange: any;
}) => (
  <div className={cn(styles.picker, className)}>
    <div className={styles.saturation}>
      <Saturation
        {...({
          hsl,
          hsv,
          pointer: SaturationPointer,
          onChange: onSaturationChange,
        } as any)}
      />
    </div>
    <div className={styles.hue}>
      <Hue
        {...({
          hsl,
          pointer: HuePointer,
          onChange: onHueChange,
        } as any)}
      />
    </div>
  </div>
);

export default React.memo(ColorPicker) as any;
